import { type FC } from 'react';
import { useIsMobileScreenSelector } from '~/store/frontendState/deviceInfo/deviceInfo.selector';
import { useSlidingAnimationMsDuration } from '~/store/frontendState/graphicSettings/graphicSettings.selectors';
import { useStreetViewSelector } from '~/store/frontendState/mapTools/streetView/streetView.selectors';
import {
  usePublicMapSettingsMarkersVisibilityButtonSelector, usePublicMapSettingsSelector,
} from '~/store/mapSettings/publicMapSettings/mapSettingsPublicMapSettings.selectors';
import { useIsMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';
import { useAreMapSettingsReadySelector } from '../../../store/mapSettings/ready/mapSettingsReady.selectors';
import { useMapSettingsSettingsIsDisableActiveToolPanelSelector } from '../../../store/mapSettings/settings/mapSettingsSettings.selectors';
import { useMapStatusBarItems } from '../../statusBar/hooks/useMapStatusBarItems';
import { useIsMobileToolPanelOpen } from '../useIsMobileToolPanelOpen.hook';
import { LeftSideMapToolsComponent } from './leftSideMapTools.component';

export const LeftSideMapToolsContainer: FC = () => {
  const isMapPresentational = useIsMapPresentationalSelector();
  const isMobileScreen = useIsMobileScreenSelector();
  const isMarkerVisibilityVisible = useMapMarkersVisibilityToggle();
  const isMobileToolPanelOpen = useIsMobileToolPanelOpen();
  const publicMapSettings = usePublicMapSettingsSelector();
  const streetView = useStreetViewSelector();
  const transitionDurationMs = useSlidingAnimationMsDuration();

  return (
    <LeftSideMapToolsComponent
      isMapPresentational={isMapPresentational}
      isMobileScreen={isMobileScreen}
      isMarkerVisibilityVisible={isMarkerVisibilityVisible}
      isMobileToolPanelOpen={isMobileToolPanelOpen}
      publicMapSettings={publicMapSettings}
      streetView={streetView}
      transitionDurationMs={transitionDurationMs}
    />
  );
};

const useMapMarkersVisibilityToggle = () => {
  const mapSettingsReady = useAreMapSettingsReadySelector();
  const isDisableActiveToolPanel = useMapSettingsSettingsIsDisableActiveToolPanelSelector();
  const isMapPresentational = useIsMapPresentationalSelector();
  const presenttationalMapMarkersVisibilityButtonEnabled = usePublicMapSettingsMarkersVisibilityButtonSelector();
  const { isAnyRemovableItem } = useMapStatusBarItems();
  const isMobileScreen = useIsMobileScreenSelector();

  const statusBarVisible = !isMapPresentational && isAnyRemovableItem && !isDisableActiveToolPanel && !isMobileScreen;
  const markersButtonEnabled = !isMapPresentational || (mapSettingsReady && presenttationalMapMarkersVisibilityButtonEnabled);

  const isVisible = !statusBarVisible && markersButtonEnabled;

  return isVisible;
};
